var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { titleCase } from '@shapeable/utils';
import { createInheritedProvider } from '@shapeable/utils';
import { useEntityTypeLabels } from './entity-type-labels-context';
import pluralize from 'pluralize';
import { mapValues } from 'lodash';
export var defaultEntityTypePluralLabelsSet = {};
export var EntityTypePluralLabelsContext = React.createContext(defaultEntityTypePluralLabelsSet);
export var EntityTypePluralLabelsProvider = createInheritedProvider(EntityTypePluralLabelsContext);
export var useEntityTypePluralLabels = function () {
  var contextLabels = React.useContext(EntityTypePluralLabelsContext);
  var labels = useEntityTypeLabels();
  // pluralize the provided set of singular labels, and merge those as the base labels.
  return __assign(__assign({}, mapValues(labels, function (label, key) {
    return pluralize.plural(label);
  })), contextLabels);
};
export var useEntityTypePluralLabel = function (entityTypeName, fallback) {
  if (fallback === void 0) {
    fallback = false;
  }
  var pluralLabels = useEntityTypePluralLabels();
  var pluralLabel = pluralLabels[entityTypeName];
  return pluralLabel || (fallback ? pluralize.plural(titleCase(entityTypeName)) : '');
};